const tableI18nDefaults = {
  'action.copy': 'Copy',
  'action.delete': 'Delete',
  'action.duplicate': 'Duplicate',
  'action.paste': 'Paste',
  'color.blue': 'Blue',
  'color.default': 'Default',
  'color.green': 'Green',
  'color.grey': 'Grey',
  'color.orange': 'Orange',
  'color.purple': 'Purple',
  'color.red': 'Red',
  'color.teal': 'Teal',
  'color.yellow': 'Yellow',
  'column.clearContents': 'Clear column contents',
  'column.clearStyle': 'Clear column style',
  'column.insertLeft': 'Insert Left',
  'column.insertRight': 'Insert Right',
  'column.moveLeft': 'Move Left',
  'column.moveRight': 'Move Right',
  'menu.backgroundColor': 'Background color',
  'row.clearContents': 'Clear row contents',
  'row.clearStyle': 'Clear row style',
  'row.insertAbove': 'Insert Above',
  'row.insertBelow': 'Insert Below',
  'row.moveDown': 'Move Down',
  'row.moveUp': 'Move Up',
  'selection.clearContents': 'Clear contents',
} as const;

export type TableI18nKey = keyof typeof tableI18nDefaults;

export type TableTranslator = (key: TableI18nKey) => string | undefined;

let tableTranslator: TableTranslator | undefined;

export function registerTableTranslator(translator: TableTranslator): void {
  tableTranslator = translator;
}

export function tableI18nT(key: TableI18nKey): string {
  return tableTranslator?.(key) ?? tableI18nDefaults[key];
}
